
import React, { useState, useEffect } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { GetCities } from "../../Services/API"
import { RaiseCabEnquiry } from "../../Services/EnquiryApi"

const CabSearch = () => {

  const [pickUpLocationSuggestions, setPickUpLocationSuggestions] = useState([]);
  const [dropLocationSuggestions, setDropLocationSuggestions] = useState([]);
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [enquiryMessage, setEnquiryMessage] = useState("");
  const [enquiryStatus, setEnquiryStatus] = useState(false);

  const [cabSearchParams, setCabSearchParams] = useState({
    travelType: "",
    pickUpLocation: "",
    dropLocation: "",
    fromDate: "",
    toDate: "",
    pickupTime: "",
    cabType: "Sedan",
    adult: 1,
    child: 0,
    infant: 0,
  });

    const swapMainDestination = (e) => {
    e.preventDefault();

    setCabSearchParams((prev) => ({
      ...prev,
      pickUpLocation: prev.dropLocation,
      dropLocation: prev.pickUpLocation,
    }));
  };

  // FETCH PickUp SUGGESTIONS
  const handlePickUpLocation = async (e) => {
    const value = e.target.value;
    if (value.length > 2) {
      const data = await GetCities(value);
      setPickUpLocationSuggestions(data?.cities || []);
    } else {
      setPickUpLocationSuggestions([]);
    }
  };


  // FETCH DROP SUGGESTIONS
  const handleDropLocation = async (e) => {
    const value = e.target.value;
    if (value.length > 2) {
      const data = await GetCities(value);
      setDropLocationSuggestions(data?.cities || []);
    } else {
      setDropLocationSuggestions([]);
    }
  };

  // SELECT PICKUP CITY
  const selectPickUpLocation = (city) => {
    const location = `${city.cityName} - ${city.countryName}`;

    setCabSearchParams((prev) => ({
      ...prev,
      pickUpLocation: location,
    }));

    setPickUpLocationSuggestions([]);
  };

  // SELECT DROP CITY
  const selectDropLocation = (city) => {
    const location = `${city.cityName} - ${city.countryName}`;

    setCabSearchParams((prev) => ({
      ...prev,
      dropLocation: location,
    }));

    setDropLocationSuggestions([]);
  };

  // HANDLE INPUT CHANGES
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCabSearchParams((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay",
      minDate: 0,
      maxDate: "+4m",
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay").offset();
          const height = $("#dateDisplay").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },

      onSelect: function (StartDate) {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });

        $("#dep_dayNum").text(day);
        $("#dep_monthYear").text(`${month}-${year}`);
        $("#dep_dayName").text(dayName);

        setCabSearchParams(prev => ({
          ...prev,
          fromDate: StartDate
        }));
      },
    });
  }, []);

  useEffect(() => {
    $("#returnDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay2",
      minDate: 0,
      // minDate: function () {
      //   const start = $("#departureDate").datepicker("getDate");
      //   return start ? start : 0;
      // },
      maxDate: "+4m",
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay2").offset();
          const height = $("#dateDisplay2").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function (endDate) {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });

        $("#ret_dayNum").text(day);
        $("#ret_monthYear").text(`${month}-${year}`);
        $("#ret_dayName").text(dayName);

        setCabSearchParams(prev => ({
          ...prev,
          toDate: endDate
        }));

      },
    });
  }, []);

  const convertToDate = (str) => {
    if (!str) return null;
    const [day, month, year] = str.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  useEffect(() => {
    if (cabSearchParams.fromDate) {
      const minD = convertToDate(cabSearchParams.fromDate);
      $("#returnDate").datepicker("option", "minDate", minD);
    }
  }, [cabSearchParams.fromDate]);

  const times = [];
  for (let h = 0; h < 24; h++) {
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    const ampm = h < 12 ? "AM" : "PM";
    times.push(`${hour12.toString().padStart(2, "0")}:00 ${ampm}`);
  }

  const handleRaiseRequest = async () => {
    let newErrors = {};

    if (!cabSearchParams.pickUpLocation.trim()) {
      newErrors.pickUp = "Please select a pickUp location";
    }
    if (!cabSearchParams.dropLocation.trim()) {
      newErrors.drop = "Please select a pickUp location";
    }

    if (!cabSearchParams.fromDate.trim()) {
      newErrors.date = "Please select Trip Start Date";
    } else {
      // const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
      // if (!datePattern.test(cabSearchParams.fromDate)) {
      //   newErrors.date = "Date must be in dd/mm/yyyy format";
      // }
    }
    if (!cabSearchParams.toDate.trim()) {
      newErrors.date = "Please select Trip End Date";
    } else {
      // const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
      // if (!datePattern.test(cabSearchParams.toDate)) {
      //   newErrors.date = "Date must be in dd/mm/yyyy format";
      // }
    }

    if (!cabSearchParams.pickupTime.trim()) {
      newErrors.pickupTime = "Please enter pick time";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    const requestBody = {
      TravelType: cabSearchParams.travelType,
      FromLocation: cabSearchParams.pickUpLocation,
      ToLocation: cabSearchParams.dropLocation,
      fromDate: cabSearchParams.fromDate,
      toDate: cabSearchParams.toDate,
      pickTime: cabSearchParams.pickupTime,
      cabType: cabSearchParams.cabType,
      noOfAdult: cabSearchParams.adult,
      noOfChild: cabSearchParams.child,
      noOfInfant: cabSearchParams.infant,
      CompanyId: "B2343",
      CreatedBy: "BerryJourneys"
    };

    try {
      const result = await RaiseCabEnquiry(requestBody);
      if (result.success) {
        setEnquiryMessage(result.message)
        setEnquiryStatus(true);
      }
      else {
        setEnquiryMessage(result.message)
      }
      // setStartDate(params.startDate);
      // setEndDate(params.endDate);
      setShowPopup(true);
    } catch {
      alert("Failed to submit enquiry");
    }
  };

  return (
    <>
      <div className='cab_serch'>
        <div className='row'>
          <div className='col-md-6 col-lg-6'>
            <div className='d-flex'>
              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="BusinessTravel"
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="BusinessTravel">
                    Business Travel
                  </label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="PersonalTravel"
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="PersonalTravel">
                    Personal Travel
                  </label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="GuestTravel"
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="GuestTravel">
                    Guest Travel
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-lg-6'>
            <div className='theme_tx'>
              {/* <h3>Fastest travel and lowest taxi prices !</h3> */}
            </div>
          </div>
        </div>

        <div className='form_ful'>
          <div className='main_frm_to'>
            <div className='pick_frm'>
              <label><i className="fa fa-location-dot"></i> Pick Up Location</label>
              <input
                type="text"
                className="pick_form"
                name="pickUpLocation"
                placeholder="Enter City.."
                value={cabSearchParams.pickUpLocation}
                onChange={(e) => {
                  handleChange(e);           // updates state
                  handlePickUpLocation(e);  // fetches suggestions
                }}
              />
              {pickUpLocationSuggestions.length > 0 && (
                <ul className="autosuggetsList">
                  {pickUpLocationSuggestions.map((city, index) => (
                    <li key={index} onClick={() => selectPickUpLocation(city)}>
                      {city.cityName} - {city.countryName}
                    </li>
                  ))}
                </ul>
              )}

              {errors.pickUp && <p className="error_mes">{errors.pickUp}</p>}
            </div>

            <div className='drop_frm'>
              <a href="/" className="swipers_cab" onClick={swapMainDestination}>
                <img alt="icon" src="/assets/images/swipe.png" />
              </a>
              <label><i className="fa fa-location-dot"></i> Drop Location</label>
              <input
                type="text"
                className="pick_form"
                name="dropLocation"
                placeholder="Enter City.."
                value={cabSearchParams.dropLocation}
                onChange={(e) => {
                  handleChange(e);           // updates state
                  handleDropLocation(e);  // fetches suggestions
                }}
              />
              {dropLocationSuggestions.length > 0 && (
                <ul className="autosuggetsList">
                  {dropLocationSuggestions.map((city, index) => (
                    <li key={index} onClick={() => selectDropLocation(city)}>
                      {city.cityName} - {city.countryName}
                    </li>
                  ))}
                </ul>
              )}
              {errors.drop && <p className="error_mes">{errors.drop}</p>}
            </div>

            <div className='cab_col_1'>
              <label><i class="fa fa-calendar-days"></i>From Date</label>
              <div
                className="dest_nam"
                id="dateDisplay"
                onClick={() => $("#departureDate").datepicker("show")}
                style={{ cursor: "pointer" }}
              >
                <span id="dep_dayNum" style={{ fontSize: "28px", fontWeight: "bold" }}>
                  DD
                </span>{" "}
                <span id="dep_monthYear" style={{ fontSize: "14px" }}>
                  MM-YYYY
                </span>
                <br />
                <span id="dep_dayName">
                  DAY
                </span>
                <input
                  type="text"
                  id="departureDate"
                  style={{ position: "absolute", left: "-9999px" }}
                  readOnly
                />
              </div>
              {errors.fromdate && <p className="error_mes">{errors.fromdate}</p>}
            </div>
            <div className='cab_col_1'>
              <label><i class="fa fa-calendar-days"></i>To Date</label>
              <div
                className="dest_nam"
                id="dateDisplay2"
                onClick={() => $("#returnDate").datepicker("show")}
                style={{ cursor: "pointer" }}
              >
                <span id="ret_dayNum" style={{ fontSize: "28px", fontWeight: "bold" }}> DD </span>{" "}
                <span id="ret_monthYear" style={{ fontSize: "14px" }}>
                  MM-YYYY
                </span>
                <br />
                <span id="ret_dayName">
                  DAY
                </span>
                <input
                  type="text"
                  id="returnDate"
                  style={{ position: "absolute", left: "-9999px" }}
                  readOnly
                />
              </div>
              {errors.Todate && <p className="error_mes">{errors.todate}</p>}
            </div>
            <div className='cab_col_1'>
              <label><i class="fa fa-clock"></i>Pick Time</label>
              <select
                className="travl_from_cab"
                id="hourSelect"
                name="pickupTime"
                value={cabSearchParams.pickupTime}
                onChange={handleChange}
              >
                <option value="">Time</option>
                {times.map((time, i) => (
                  <option key={i} value={time}>
                    {time}
                  </option>
                ))}
              </select>
              {errors.pickupTime && <p className="error_mes">{errors.pickupTime}</p>}
            </div>
            <div className='cab_col_1'>
              <label><i class="fa fa-car"></i>Cab Type</label>
              <select className='multi_selct'
                name="cabType"
                value={cabSearchParams.cabType}
                onChange={handleChange}
              >
                <option>Sedan</option>
                <option> MUV</option>
                <option> SUV </option>
                <option> Luxury </option>
              </select>
            </div>
            <div className='Rooms_Guests_Serch'>
              {/* <a className='Serch' href='/'>Raise Request</a> */}
              <button className="Serch" onClick={handleRaiseRequest} type="button">
                Raise Request
              </button>
            </div>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h3>{enquiryMessage}</h3>
            {/* {enquiryStatus && (
              <>
                <h5>Your Enquiry Details</h5>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Travelling To</th>
                      <th>Travel Type</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Travel Days</th>
                      <th>Adult</th>
                      <th>Child</th>
                      <th>Infant</th>
                      <th>Total Pax</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{countries.find((c) => c.countryCode === selectedCountry)?.countryName || "-"}</td>
                      <td>{travelType || "-"}</td>
                      <td>{startDate || "-"}</td>
                      <td>{endDate || "-"}</td>
                      <td>{travelDays || "-"}</td>
                      <td>{adults}</td>
                      <td>{children}</td>
                      <td>{infant}</td>
                      <td>{totalTravellers || "-"}</td>

                    </tr>
                  </tbody>
                </table>
              </>
            )} */}
            <button
              onClick={() => {
                setShowPopup(false);
                window.location.reload();
              }}
              className="btn btn-primary"
            >
              Ok
            </button>
          </div>
        </div>
      )}

    </>
  );
};

export default CabSearch;